import { Component } from '@angular/core';
import { Company } from 'src/shared/api';
import { NgControl, FormBuilder } from '@angular/forms';
import {
	CustomFormAccessor,
	FormConfig,
} from 'src/shared/form-models/form-cva.component';

const companyFormConfig: FormConfig<Company> = {
	id: [''],
	name: [''],
	employerIdentificationNumber: [''],
	contacts: [''],
	companyAddresses: [''],
	defaultAddress: ['']
};

@Component({
	selector: 'rpfsa-company-1099',
	templateUrl: './company-1099.component.html',
})
export class Company1099Component extends CustomFormAccessor<Company> {
	constructor(public ngControl: NgControl, public fb: FormBuilder) {
		super(ngControl, fb, companyFormConfig);
	}
}
